var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightLong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.504.36l-.219.19a.37.37 0 000 .466l2.297 2.27H.328A.332.332 0 000 3.612v.274c0 .191.137.328.328.328h10.254L8.285 6.512a.37.37 0 000 .465l.219.191c.11.137.328.137.465 0l3.172-3.172a.315.315 0 000-.465L8.969.36c-.137-.136-.356-.136-.465 0z",
    fill: "#868E96"
  })));
}
export default SvgArrowRightLong;